@if (label) {
  <div class="label">{{ label }}</div>
}
<div class="select-wrapper">
  <nz-select
    #selectElement
    [(ngModel)]="value"
    [nzPlaceHolder]="placeholder"
    [nzDisabled]="disabled"
    [nzOptions]="options"
    [nzSuffixIcon]="suffixIcon"
    [nzCustomTemplate]="selectedTemplate"
    [ngStyle]="{'width': customWidth}"
    [ngClass]="{
      'width-responsive': widthType === 'responsive',
    }"
    (ngModelChange)="onValueChange($event)"
    (nzOpenChange)="onOpenChange($event)"
    [nzOptionHeightPx]="38"
  ></nz-select>
</div>

<ng-template #selectedTemplate>
  <span>{{ displayText() }}</span>
</ng-template>

<ng-template #suffixIcon>
  @if (suffixNzIcon) {
    <nz-icon [nzType]="suffixNzIcon" />
  }
  @if (suffixImgIcon) {
    <svg-icon [src]="'assets/icons/' + suffixImgIcon" />
  }
</ng-template>
